import { OnboardingQuery } from './Onboarding.query';

const Onboarding = () => {
  return <OnboardingQuery />;
};

export { Onboarding };
